"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddSessionForm = _interopRequireDefault(require("./AddSessionForm"));
var _utils = require("../../../utils");
var _excluded = ["onCancel", "visible"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Title = _typography.default.Title;
var AddSessionModal = function AddSessionModal(props) {
  var onCancel = props.onCancel,
    visible = props.visible,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isEditForm = !!otherProps.session;
  var _useRequest = (0, _utils.useRequest)((0, _utils.getPublicClinicianListUrl)()),
    groupModerators = _useRequest.data,
    loadingGroupModerators = _useRequest.loading;
  if (loadingGroupModerators) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_modal.default, {
    footer: null,
    visible: visible,
    onCancel: onCancel,
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 3
    }, isEditForm ? 'Edit' : 'Add', " session"),
    className: "add-session",
    destroyOnClose: true
  }, /*#__PURE__*/_react.default.createElement(_AddSessionForm.default, _extends({}, otherProps, {
    moderators: groupModerators,
    onCancel: onCancel
  })));
};
AddSessionModal.propTypes = {
  clinicians: _propTypes.default.array,
  isEditable: _propTypes.default.bool,
  loadingClinicians: _propTypes.default.bool,
  newGroup: _propTypes.default.object,
  onCancel: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  processing: _propTypes.default.bool,
  visible: _propTypes.default.bool
};
var _default = AddSessionModal;
exports.default = _default;